import { render, staticRenderFns } from "./ActivitiesWithIssuesSummary.vue?vue&type=template&id=40207a0f&"
import script from "./ActivitiesWithIssuesSummary.vue?vue&type=script&lang=js&"
export * from "./ActivitiesWithIssuesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports